const getDefaultSMSProvider = function (state) {
  const { smsProviders, providerDefaults } = state

  const defaultProvider = smsProviders?.find(
    provider => provider.conversationProvider.default
  )

  const providerId = defaultProvider?.conversationProvider?._id

  return providerDefaults?.SMS
    ? providerDefaults?.SMS
    : providerId
    ? providerId
    : smsProviders[0]?.conversationProvider?._id
}

export default getDefaultSMSProvider
